import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import ReactTableComponent from "../../components/Table/ReactTableComponent";
import { Spinner } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
function Trip() {
  const COLUMNS = [
    {
      width:'500px',
      Header: "Action",
      Footer: "Action",
    
      accessor: (originalRow, rowIndex) => {
        return (
          <>

            <UncontrolledDropdown className="menu-dropdown">
              <DropdownToggle>
                <div className="dots"></div>
                <div className="dots"> </div>
                <div className="dots"></div>
              </DropdownToggle>
              <DropdownMenu>

                <Row>
                  <Col>
                    <button
                      data-tip
                      data-for="TripOrders"
                      onClick={(e) => {
                        history.push(`/admin/trip-order/${originalRow.Id}`);
                      }}
                      className="btn-edit"
                    >
                      <i className="now-ui-icons tech_watch-time" />
                      Orders
                    </button>
                    <ReactTooltip id="TripOrders" place="top" effect="solid">
                      Trip Orders
                    </ReactTooltip>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {originalRow.Status == 2 ? (
                      <>
                        <button
                          data-tip
                          data-for="CancelTrip"
                          onClick={(e) => {
                            cancelTrip(originalRow.Id)
                          }}
                          className="btn-edit"
                        >
                          <i className="now-ui-icons design-2_ruler-pencil" />
                          Cancel
                        </button>
                        <ReactTooltip id="CancelTrip" place="top" effect="solid">
                          Cancel Trip
                        </ReactTooltip>
                       
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>


                <Row>
                  <Col>
                    {originalRow.Status != 3 && originalRow.Status != 4 ? (
                      <>
                        <button
                          data-tip
                          data-for="EditTrip"
                          onClick={(e) => {
                            history.push(`/admin/manage-trip/${originalRow.Id}`);
                          }}
                          className="btn-edit"
                        >
                          <i className="now-ui-icons design-2_ruler-pencil" />
                          Edit
                        </button>
                        <ReactTooltip id="EditTrip" place="top" effect="solid">
                          Edit Trip
                        </ReactTooltip>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                
                <Row>
                  <Col>
                    {originalRow.Status != 3 && originalRow.Status != 4 ? (
                      <>
                        <button
                          data-tip
                          data-for="DeleteTrip"
                          onClick={(e) => deleteTrip(originalRow.Id)}
                          className="btn-edit"
                        >
                          <i className="now-ui-icons ui-1_simple-remove" />
                          Delete
                        </button>
                        <ReactTooltip id="DeleteTrip" place="top" effect="solid">
                          Delete Trip
                        </ReactTooltip>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        );
      },
     
      Cell: ({ value }) => {

        return value;
      },
    },
    {
      Header: "Trip Number",
      Footer: "Trip Number",
      accessor: "TripNumber",
    },
    {
      Header: "Trip Start Date",
      Footer: "Trip Start Date",
      accessor: "StartDateStr",
    },
    {
      Header: "Trip End Date",
      Footer: "Trip End Date",
      accessor: "EndDateStr",
    },
    {
      Header: "Driver Name",
      Footer: "Driver Name",
      accessor: "FullName",
    },
    {
      Header: "Trip Status",
      Footer: "Trip Status",
      accessor: "TripStatus",
    },

  ];
  const [tripStatus, setTripStatus] = useState([]);
  const [trips, setTrips] = useState([]);
  const history = useHistory();
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => trips, []);
  const [IsLoading, setIsLoading] = useState(true)
  useEffect(() => {
    loadTripStatus();
    loadTrips(0);
  }, []);

  const loadTripStatus = () => {
    var response = callAPI(`/api/trip-status`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        setTripStatus(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onInputChange = (e) => {
    e.preventDefault();
    loadTrips(e.target.value);
  };

  const loadTrips = (status) => {
    var response = callAPI(`/api/trips/0/${status}`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        setTrips(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteTrip = async (id) => {
    if (confirm("Are you sure you want to delete this trip?")) {
      setIsLoading(true)
      var response = callAPI(`/api/trips/${id}`, "DELETE", null);
      response.then((res) => {
        setIsLoading(false)
        if (res.success) {
          toast.success("Trip Deleted Successfully!!!");
          loadTrips(0);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  const cancelTrip = async (id) => {
    if (confirm("Are you sure you want to cancel this trip?")) {
      setIsLoading(true)
      var response = callAPI(`/api/canceltrips/${id}`, "GET", null);
      response.then((res) => {
        setIsLoading(false)
        if (res.success) {
          toast.success(res.message);
          loadTrips(0);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  let renderRow = trips.map((trip) => {
    return (
      <tr key={trip.Id}>
        <td className="td-actions text-left">
          <button
            data-tip
            data-for="TripOrders"
            onClick={(e) => {
              history.push(`/admin/trip-order/${trip.Id}`);
            }}
            className="btn btn-primary"
          >
            <i className="now-ui-icons tech_watch-time" />
          </button>
          <ReactTooltip id="TripOrders" place="top" effect="solid">
            Trip Orders
          </ReactTooltip>
          &nbsp;
          {trip.Status == 2 ? (
            <>
              <button
                data-tip
                data-for="CancelTrip"
                onClick={(e) => {
                  cancelTrip(trip.Id)
                }}
                className="btn btn-warning"
              >
                <i className="now-ui-icons design-2_ruler-pencil" />
              </button>
              <ReactTooltip id="CancelTrip" place="top" effect="solid">
                Cancel Trip
              </ReactTooltip>
              &nbsp;
            </>
          ) : (
            ""
          )}
          {trip.Status != 3 && trip.Status != 4 ? (
            <>
              <button
                data-tip
                data-for="EditTrip"
                onClick={(e) => {
                  history.push(`/admin/manage-trip/${trip.Id}`);
                }}
                className="btn btn-info"
              >
                <i className="now-ui-icons design-2_ruler-pencil" />
              </button>
              <ReactTooltip id="EditTrip" place="top" effect="solid">
                Edit Trip
              </ReactTooltip>
              &nbsp;
              <button
                data-tip
                data-for="DeleteTrip"
                onClick={(e) => deleteTrip(trip.Id)}
                className="btn btn-danger"
              >
                <i className="now-ui-icons ui-1_simple-remove" />
              </button>
              <ReactTooltip id="DeleteTrip" place="top" effect="solid">
                Delete Trip
              </ReactTooltip>
            </>
          ) : (
            ""
          )}
        </td>
        <td className="text-left">{trip.TripNumber}</td>
        <td className="text-left">{trip.StartDateStr}</td>
        <td className="text-left">{trip.EndDateStr}</td>
        <td className="text-left">{trip.FullName}</td>
        <td className="text-left">{trip.TripStatus}</td>
      </tr>
    );
  });

  let renderStatusOptions =
    tripStatus.length > 0 || tripStatus.roles != undefined
      ? tripStatus.map((st) => {
        return (
          <option key={st.Id} value={st.Id}>
            {st.Status}
          </option>
        );
      })
      : "";

  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>

      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col md={4}>
                    <CardTitle tag="h4">
                      Trip Management
                    </CardTitle>
                  </Col>
                  <Col md={3}>
                    <select className="form-control h38"
                      name="Status"
                      id="ddlTripStatus"
                      onChange={(e) => onInputChange(e)}
                    >
                      <option value="0">All</option>
                      { }
                      {renderStatusOptions}
                    </select>
                  </Col>
                  <Col md={3}></Col>
                  <Col className="text-right">
                    <button
                      className="btn btn-info pull-right"
                      onClick={(e) => {
                        history.push("/admin/manage-trip");
                      }}
                    >
                      Add Trip
                    </button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {trips.length ? (
                <>
               
                <ReactTableComponent data={trips} columns={columns} />
               
                
                  </>
                ) : null}
                {/* <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Trip Number</th>
                      <th>Trip Start Date</th>
                      <th>Trip End Date</th>
                      <th>Driver Name</th>
                      <th>Trip Status</th>
                    </tr>
                  </thead>
                  <tbody>{renderRow}</tbody>
                </Table>
               */}
              </CardBody>
              <CardFooter>
                <div className="stats"></div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Trip;
